// blogPostsSet4.js - Artículos Set 4 (16-20) - Dietas, calorías y mitos

export const blogPostsSet4 = [
  // ARTÍCULO 16 - Dieta Mediterránea
  {
    id: 116,
    slug: "dieta-mediterranea-principiantes-guia-completa-2026",
    seoTitle: "Dieta Mediterránea para Principiantes: Qué Comer",
    title: "Dieta Mediterránea para Principiantes: Qué Comer y Cómo Empezar",
    excerpt: "Guía completa de la dieta mediterránea: qué es, beneficios científicos, alimentos permitidos, plan de comidas y por qué es considerada la dieta más saludable del mundo.",
    content: `
      <div class="blog-article-extended">

        <p class="lead">La <strong>dieta mediterránea</strong> ha sido nombrada repetidamente como <strong>la dieta más saludable del mundo</strong> por expertos en nutrición.</p>

        <p>En esta guía aprenderás todo lo que necesitas para empezar.</p>

        <h2>¿Qué es la Dieta Mediterránea?</h2>

        <p>No es una "dieta" en el sentido restrictivo, sino un <strong>estilo de vida alimentario</strong> basado en los hábitos tradicionales de países como:</p>
        <ul>
          <li>🇮🇹 Italia</li>
          <li>🇬🇷 Grecia</li>
          <li>🇪🇸 España</li>
          <li>🇹🇷 Turquía</li>
        </ul>

        <h2>Principios Básicos</h2>

        <h3>Come ABUNDANTE:</h3>
        <ul>
          <li>✅ Vegetales y frutas (diario)</li>
          <li>✅ Granos integrales (pan, pasta, arroz)</li>
          <li>✅ Legumbres (garbanzos, lentejas, frijoles)</li>
          <li>✅ Frutos secos y semillas</li>
          <li>✅ Aceite de oliva extra virgen (grasa principal)</li>
        </ul>

        <h3>Come MODERADO:</h3>
        <ul>
          <li>⚖️ Pescado y mariscos (2-3 veces/semana)</li>
          <li>⚖️ Aves de corral (2 veces/semana)</li>
          <li>⚖️ Huevos (4-7/semana)</li>
          <li>⚖️ Lácteos (yogur, queso)</li>
        </ul>

        <h3>Come POCO:</h3>
        <ul>
          <li>⚠️ Carne roja (1-2 veces/mes)</li>
          <li>⚠️ Dulces (ocasional)</li>
          <li>⚠️ Procesados (evitar)</li>
        </ul>

        <h3>Bebidas:</h3>
        <ul>
          <li>✅ Agua (principal)</li>
          <li>✅ Vino tinto (opcional, 1 copa/día con comidas)</li>
          <li>❌ Refrescos, jugos procesados</li>
        </ul>

        <h2>Beneficios Científicos Comprobados</h2>

        <h3>1. Salud Cardiovascular</h3>
        <p>Estudio PREDIMED (2013): Reduce riesgo de infarto y ACV en <strong>30%</strong></p>

        <h3>2. Longevidad</h3>
        <p>Personas que siguen dieta mediterránea viven <strong>2-3 años más</strong> en promedio</p>

        <h3>3. Pérdida de Peso Sostenible</h3>
        <p>No es una dieta restrictiva, pero ayuda a perder peso de forma <strong>natural y sostenible</strong></p>

        <h3>4. Salud Cerebral</h3>
        <p>Reduce riesgo de Alzheimer y deterioro cognitivo en <strong>35-40%</strong></p>

        <h3>5. Control de Diabetes</h3>
        <p>Mejora sensibilidad a la insulina y control de azúcar en sangre</p>

        <h2>Alimentos Clave</h2>

        <table class="mediterranean-foods">
          <tr>
            <th>Categoría</th>
            <th>Alimentos</th>
            <th>Frecuencia</th>
          </tr>
          <tr>
            <td>Vegetales</td>
            <td>Tomate, espinaca, brócoli, berenjena, calabacín</td>
            <td>Diario (abundante)</td>
          </tr>
          <tr>
            <td>Frutas</td>
            <td>Naranjas, uvas, fresas, higos, manzanas</td>
            <td>Diario (2-3 porciones)</td>
          </tr>
          <tr>
            <td>Granos</td>
            <td>Pan integral, pasta integral, arroz integral, bulgur</td>
            <td>Diario</td>
          </tr>
          <tr>
            <td>Legumbres</td>
            <td>Garbanzos, lentejas, frijoles blancos</td>
            <td>3+ veces/semana</td>
          </tr>
          <tr>
            <td>Pescado</td>
            <td>Salmón, sardinas, atún, bacalao</td>
            <td>2-3 veces/semana</td>
          </tr>
          <tr>
            <td>Aceite</td>
            <td>Aceite de oliva extra virgen</td>
            <td>Diario (3-4 cucharadas)</td>
          </tr>
        </table>

        <h2>Plan de Comidas Ejemplo (1 Día)</h2>

        <div class="meal-plan">
          <h3>🍳 Desayuno</h3>
          <ul>
            <li>Pan integral tostado con tomate rallado</li>
            <li>1 cucharada de aceite de oliva</li>
            <li>Yogur griego con miel y nueces</li>
            <li>1 naranja</li>
          </ul>

          <h3>🥗 Almuerzo</h3>
          <ul>
            <li>Ensalada griega (tomate, pepino, cebolla, aceitunas, queso feta)</li>
            <li>2 cucharadas de aceite de oliva + limón</li>
            <li>150g pescado a la parrilla</li>
            <li>Pan integral</li>
          </ul>

          <h3>🍲 Cena</h3>
          <ul>
            <li>Pasta integral con salsa de tomate natural</li>
            <li>Albóndigas de pollo con hierbas</li>
            <li>Vegetales asados (berenjena, calabacín, pimientos)</li>
            <li>Copa de vino tinto (opcional)</li>
          </ul>

          <h3>🍎 Snacks</h3>
          <ul>
            <li>30g almendras</li>
            <li>1 manzana</li>
            <li>Hummus con vegetales crudos</li>
          </ul>
        </div>

        <h2>Diferencias con Otras Dietas</h2>

        <table class="diet-comparison">
          <tr>
            <th></th>
            <th>Mediterránea</th>
            <th>Keto</th>
            <th>Vegana</th>
          </tr>
          <tr>
            <td><strong>Carbohidratos</strong></td>
            <td>✅ Moderados (integrales)</td>
            <td>❌ Muy bajos</td>
            <td>✅ Altos</td>
          </tr>
          <tr>
            <td><strong>Grasas</strong></td>
            <td>✅ Saludables (oliva)</td>
            <td>✅ Muy altas</td>
            <td>⚠️ Moderadas</td>
          </tr>
          <tr>
            <td><strong>Proteína animal</strong></td>
            <td>✅ Pescado, poco carne</td>
            <td>✅ Permitida</td>
            <td>❌ No</td>
          </tr>
          <tr>
            <td><strong>Sostenibilidad</strong></td>
            <td>✅ Muy alta</td>
            <td>⚠️ Media</td>
            <td>✅ Alta</td>
          </tr>
        </table>

        <h2>Cómo Wayo Te Ayuda con la Dieta Mediterránea</h2>

        <ul class="wayo-features">
          <li>📌 Identifica alimentos mediterráneos vs procesados</li>
          <li>📌 Sugiere recetas mediterráneas según tus ingredientes</li>
          <li>📌 Alerta si consumes mucha carne roja (debería ser poco)</li>
          <li>📌 Seguimiento de aceite de oliva y grasas saludables</li>
        </ul>

        <div class="faq-section">
          <h4>¿La dieta mediterránea sirve para perder peso?</h4>
          <p>Sí, aunque no es su objetivo principal. Ayuda a perder peso de forma natural y sostenible (0.5-1 kg/semana).</p>

          <h4>¿Puedo hacer dieta mediterránea siendo vegetariano?</h4>
          <p>Sí, perfectamente. Enfócate en legumbres, granos integrales, vegetales, frutos secos y lácteos.</p>

          <h4>¿Es cara la dieta mediterránea?</h4>
          <p>No necesariamente. Legumbres, granos, vegetales de temporada y aceite de oliva son económicos. El pescado puede ser más caro, pero se consume solo 2-3 veces/semana.</p>
        </div>

      </div>
    `,
    image: "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=1200",
    author: "Wayo Team",
    date: "2026-02-17",
    category: "Nutrición",
    tags: ["dieta mediterránea", "salud", "nutrición", "longevidad", "corazón"],
    readTime: "15 min",
    metaDescription: "Aprende qué alimentos priorizar, cómo montar tus platos y por qué la dieta mediterránea sigue siendo una de las mejores opciones para tu salud.",
    keywords: ["dieta mediterránea", "dieta mediterránea principiantes", "beneficios dieta mediterránea", "plan comidas mediterráneo"]
  },

  // ARTÍCULO 17 - Cuántas Calorías para Perder Peso
  {
    id: 117,
    slug: "cuantas-calorias-deberias-comer-para-perder-peso",
    title: "¿Cuántas Calorías Deberías Comer para Perder Peso? Calculadora + Errores",
    excerpt: "Descubre exactamente cuántas calorías necesitas para perder peso de forma saludable. Incluye calculadora, ejemplos prácticos y cómo evitar errores comunes.",
    content: `
      <div class="blog-article-extended">

        <p class="lead">La pregunta más importante en pérdida de peso: <strong>¿cuántas calorías debo comer?</strong></p>

        <p>En esta guía aprenderás a calcular tu número exacto.</p>

        <h2>Paso 1: Calcula tu Metabolismo Basal (TMB)</h2>

        <p>El TMB es la cantidad de calorías que tu cuerpo quema <strong>en reposo absoluto</strong> (sin hacer nada).</p>

        <h3>Fórmula de Harris-Benedict:</h3>

        <div class="formula-box">
          <h4>Para Mujeres:</h4>
          <p>TMB = 655 + (9.6 × peso kg) + (1.8 × altura cm) - (4.7 × edad)</p>

          <h4>Para Hombres:</h4>
          <p>TMB = 66 + (13.7 × peso kg) + (5 × altura cm) - (6.8 × edad)</p>
        </div>

        <h2>Paso 2: Multiplica por tu Nivel de Actividad</h2>

        <table class="activity-multiplier">
          <tr>
            <th>Nivel de actividad</th>
            <th>Factor</th>
            <th>Descripción</th>
          </tr>
          <tr>
            <td>Sedentario</td>
            <td>× 1.2</td>
            <td>Trabajo de oficina, poco ejercicio</td>
          </tr>
          <tr>
            <td>Ligero</td>
            <td>× 1.375</td>
            <td>Ejercicio 1-3 días/semana</td>
          </tr>
          <tr>
            <td>Moderado</td>
            <td>× 1.55</td>
            <td>Ejercicio 3-5 días/semana</td>
          </tr>
          <tr>
            <td>Activo</td>
            <td>× 1.725</td>
            <td>Ejercicio 6-7 días/semana</td>
          </tr>
          <tr>
            <td>Muy activo</td>
            <td>× 1.9</td>
            <td>Ejercicio 2 veces/día, trabajo físico</td>
          </tr>
        </table>

        <h2>Paso 3: Crea un Déficit Calórico</h2>

        <p>Para perder peso de forma <strong>saludable y sostenible</strong>:</p>

        <table class="deficit-guide">
          <tr>
            <th>Déficit diario</th>
            <th>Pérdida semanal</th>
            <th>Recomendado para</th>
          </tr>
          <tr>
            <td>200-300 kcal</td>
            <td>0.25-0.4 kg</td>
            <td>Personas con poco peso a perder (últimos 5 kg)</td>
          </tr>
          <tr>
            <td>300-500 kcal</td>
            <td>0.5-0.7 kg</td>
            <td>✅ IDEAL - Sostenible a largo plazo</td>
          </tr>
          <tr>
            <td>500-750 kcal</td>
            <td>0.7-1 kg</td>
            <td>Personas con sobrepeso significativo</td>
          </tr>
          <tr>
            <td>1000+ kcal</td>
            <td>1+ kg</td>
            <td>❌ NO RECOMENDADO - Riesgo de rebote</td>
          </tr>
        </table>

        <h2>Ejemplos Prácticos Completos</h2>

        <div class="example-box">
          <h3>Ejemplo 1: Mujer, 30 años, 70kg, 165cm, sedentaria</h3>

          <h4>Paso 1 - TMB:</h4>
          <p>TMB = 655 + (9.6 × 70) + (1.8 × 165) - (4.7 × 30)</p>
          <p>TMB = 655 + 672 + 297 - 141 = <strong>1,483 kcal</strong></p>

          <h4>Paso 2 - Gasto Total:</h4>
          <p>1,483 × 1.2 (sedentaria) = <strong>1,780 kcal/día</strong></p>

          <h4>Paso 3 - Déficit:</h4>
          <p>1,780 - 400 = <strong>1,380 kcal/día</strong> para perder peso</p>

          <h4>Resultado esperado:</h4>
          <p>Pérdida de <strong>0.5-0.7 kg por semana</strong></p>
        </div>

        <div class="example-box">
          <h3>Ejemplo 2: Hombre, 35 años, 85kg, 178cm, moderadamente activo</h3>

          <h4>Paso 1 - TMB:</h4>
          <p>TMB = 66 + (13.7 × 85) + (5 × 178) - (6.8 × 35)</p>
          <p>TMB = 66 + 1,165 + 890 - 238 = <strong>1,883 kcal</strong></p>

          <h4>Paso 2 - Gasto Total:</h4>
          <p>1,883 × 1.55 (moderado) = <strong>2,919 kcal/día</strong></p>

          <h4>Paso 3 - Déficit:</h4>
          <p>2,919 - 500 = <strong>2,419 kcal/día</strong> para perder peso</p>

          <h4>Resultado esperado:</h4>
          <p>Pérdida de <strong>0.7-1 kg por semana</strong></p>
        </div>

        <h2>Límites Mínimos (IMPORTANTE)</h2>

        <div class="warning-box">
          <h3>⚠️ NO bajes de:</h3>
          <ul>
            <li><strong>Mujeres:</strong> 1,200 kcal/día</li>
            <li><strong>Hombres:</strong> 1,500 kcal/día</li>
          </ul>

          <h4>¿Por qué?</h4>
          <p>Comer muy poco causa:</p>
          <ul>
            <li>❌ Pérdida de masa muscular</li>
            <li>❌ Metabolismo más lento</li>
            <li>❌ Deficiencias nutricionales</li>
            <li>❌ Hambre extrema → efecto rebote</li>
            <li>❌ Fatiga, irritabilidad</li>
          </ul>
        </div>

        <h2>Ajustes según Resultados</h2>

        <h3>Si NO estás perdiendo peso después de 2-3 semanas:</h3>
        <ul>
          <li>✅ Reduce 100-200 kcal más</li>
          <li>✅ Aumenta actividad física (camina 2,000 pasos más)</li>
          <li>✅ Revisa que estés midiendo correctamente</li>
        </ul>

        <h3>Si estás perdiendo MÁS de 1 kg/semana:</h3>
        <ul>
          <li>⚠️ Aumenta 100-200 kcal (especialmente proteína)</li>
          <li>⚠️ Asegura 1.6-2g proteína/kg</li>
          <li>⚠️ Entrena con pesas para preservar músculo</li>
        </ul>

        <h2>Errores Comunes al Calcular Calorías</h2>

        <h3>❌ Error 1: Sobreestimar tu actividad</h3>
        <p>Muchas personas se consideran "activas" cuando en realidad son "ligeras".</p>
        <p><strong>Solución:</strong> Empieza con el nivel más bajo y ajusta según resultados.</p>

        <h3>❌ Error 2: No ajustar según progreso</h3>
        <p>A medida que pierdes peso, tu cuerpo necesita menos calorías.</p>
        <p><strong>Solución:</strong> Recalcula cada 5-7 kg perdidos.</p>

        <h3>❌ Error 3: Crear un déficit demasiado agresivo</h3>
        <p>Comer 1,000 kcal cuando deberías comer 1,800 kcal.</p>
        <p><strong>Solución:</strong> Déficit moderado = resultados sostenibles.</p>

        <h2>Cómo Wayo Simplifica Todo Esto</h2>

        <p>En lugar de hacer cálculos manuales:</p>

        <ul class="wayo-features">
          <li>📌 Ingresas tu edad, peso, altura, objetivo</li>
          <li>📌 Wayo calcula tu déficit automáticamente</li>
          <li>📌 Cada comida escaneada te dice si estás en camino</li>
          <li>📌 Ajusta automáticamente según tu progreso</li>
          <li>📌 Alerta si comes muy poco (bajo mínimos)</li>
        </ul>

        <div class="faq-section">
          <h4>¿Tengo que contar calorías para siempre?</h4>
          <p>No. Una vez que alcanzas tu peso objetivo y aprendes porciones, puedes mantener sin contar.</p>

          <h4>¿Puedo comer lo que quiera si cumplo mis calorías?</h4>
          <p>Técnicamente sí (déficit calórico funciona), pero la calidad nutricional importa para saciedad, salud y energía.</p>

          <h4>¿Qué pasa si un día me paso de calorías?</h4>
          <p>Nada grave. Lo que importa es el balance semanal, no un día aislado. Simplemente vuelve a tu plan al día siguiente.</p>
        </div>

      </div>
    `,
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200",
    author: "Wayo Team",
    date: "2026-02-19",
    category: "Pérdida de Peso",
    tags: ["calorías", "pérdida de peso", "déficit calórico", "calculadora", "nutrición"],
    readTime: "13 min",
    metaDescription: "Descubre tu déficit ideal para perder peso con calculadora, ejemplos reales y los errores más comunes que hacen fallar este cálculo.",
    keywords: ["cuántas calorías para perder peso", "calculadora déficit calórico", "calorías para adelgazar", "déficit calórico"]
  },

  // ARTÍCULO 18 - Calorías Caminando 10,000 Pasos
  {
    id: 118,
    slug: "cuantas-calorias-quemas-caminando-10000-pasos",
    seoTitle: "¿Cuántas Calorías Quemas con 10.000 Pasos? Tabla por Peso",
    title: "¿Cuántas Calorías Quemas Caminando 10.000 Pasos? Tabla Real por Peso (2026)",
    excerpt: "Entre 200 y 500 kcal: la diferencia depende de tu peso. Tabla exacta para 60, 70, 80 y 90 kg, factores clave y cómo quemar más en el mismo tiempo.",
    content: `
      <div class="blog-article-extended">

        <p class="lead">Caminar 10,000 pasos al día es una de las recomendaciones más populares para mantenerse activo. Pero, <strong>¿cuántas calorías realmente quemas?</strong></p>

        <div class="info-box">
          <h3>⚡ Respuesta rápida</h3>
          <p>Caminar <strong>10.000 pasos quema entre 300 y 500 kcal</strong> en la mayoría de personas: unas 30-50 kcal por cada 1.000 pasos. Depende sobre todo de tu peso y ritmo — una persona de 60 kg quema ~300-360 kcal y una de 90 kg, ~450-540 kcal. Abajo tienes la <strong>tabla exacta por peso</strong>, y para saber cuántas calorías puedes comer al día usa la <a href="/blog/cuantas-calorias-consumir-al-dia-calculadora">calculadora de calorías diarias</a>.</p>
        </div>

        <h2>Tabla: Calorías Quemadas según Peso</h2>

        <table class="calories-walking">
          <tr>
            <th>Peso corporal</th>
            <th>Calorías (10,000 pasos)</th>
            <th>Calorías por paso</th>
          </tr>
          <tr>
            <td>50 kg</td>
            <td>250-300 kcal</td>
            <td>0.025-0.03 kcal</td>
          </tr>
          <tr>
            <td>60 kg</td>
            <td>300-360 kcal</td>
            <td>0.03-0.036 kcal</td>
          </tr>
          <tr>
            <td>70 kg</td>
            <td>350-420 kcal</td>
            <td>0.035-0.042 kcal</td>
          </tr>
          <tr>
            <td>80 kg</td>
            <td>400-480 kcal</td>
            <td>0.04-0.048 kcal</td>
          </tr>
          <tr>
            <td>90 kg</td>
            <td>450-540 kcal</td>
            <td>0.045-0.054 kcal</td>
          </tr>
          <tr>
            <td>100 kg</td>
            <td>500-600 kcal</td>
            <td>0.05-0.06 kcal</td>
          </tr>
        </table>

        <h2>Fórmula Aproximada</h2>

        <div class="formula-box">
          <h3>Método simple:</h3>
          <p><strong>Calorías ≈ Peso (kg) × 0,0005 × Número de pasos</strong></p>

          <h4>Ejemplo: Persona de 70 kg caminando 10,000 pasos</h4>
          <p>70 × 0,0005 × 10.000 = <strong>350 kcal</strong></p>
        </div>

        <h2>Factores que Afectan la Quema de Calorías</h2>

        <h3>1. Velocidad de Caminata</h3>

        <table class="speed-comparison">
          <tr>
            <th>Velocidad</th>
            <th>Ritmo</th>
            <th>Calorías (70kg, 10k pasos)</th>
          </tr>
          <tr>
            <td>Lento</td>
            <td>3 km/h</td>
            <td>300 kcal</td>
          </tr>
          <tr>
            <td>Moderado</td>
            <td>5 km/h</td>
            <td>380 kcal</td>
          </tr>
          <tr>
            <td>Rápido</td>
            <td>6.5 km/h</td>
            <td>450 kcal</td>
          </tr>
        </table>

        <p><strong>Diferencia:</strong> Caminar rápido puede quemar <strong>50% más calorías</strong> que caminar lento.</p>

        <h3>2. Inclinación / Terreno</h3>

        <ul>
          <li>🏙️ <strong>Plano:</strong> 350 kcal (base)</li>
          <li>⛰️ <strong>Subida ligera (5%):</strong> 450 kcal (+28%)</li>
          <li>🏔️ <strong>Subida moderada (10%):</strong> 550 kcal (+57%)</li>
          <li>🥾 <strong>Montaña/senderismo:</strong> 600-700 kcal (+71-100%)</li>
        </ul>

        <h3>3. Peso Corporal</h3>

        <p>A mayor peso, más calorías quemadas:</p>
        <ul>
          <li>Persona de 60 kg: 300 kcal</li>
          <li>Persona de 90 kg: 450 kcal</li>
        </ul>
        <p><strong>Diferencia:</strong> 50% más calorías con 50% más peso</p>

        <h3>4. Edad y Condición Física</h3>

        <ul>
          <li>⚡ Jóvenes (20-30 años): Mayor gasto metabólico</li>
          <li>⚖️ Adultos (40-50 años): Gasto moderado</li>
          <li>🧓 Mayores (60+ años): Menor gasto (pero caminar es igual de beneficioso)</li>
        </ul>

        <h2>¿Cuánto Tiempo Toma Caminar 10,000 Pasos?</h2>

        <table class="time-steps">
          <tr>
            <th>Velocidad</th>
            <th>Tiempo aproximado</th>
            <th>Distancia</th>
          </tr>
          <tr>
            <td>Lento (3 km/h)</td>
            <td>2.5 horas</td>
            <td>~7.5 km</td>
          </tr>
          <tr>
            <td>Moderado (5 km/h)</td>
            <td>1.5 horas</td>
            <td>~7.5 km</td>
          </tr>
          <tr>
            <td>Rápido (6.5 km/h)</td>
            <td>1 hora 10 min</td>
            <td>~7.5 km</td>
          </tr>
        </table>

        <p><strong>Promedio:</strong> 10,000 pasos = ~7-8 km = ~90-120 minutos</p>

        <h2>Cómo Maximizar la Quema de Calorías</h2>

        <h3>1. Aumenta la Velocidad</h3>
        <p>Camina a ritmo rápido (6+ km/h) → quemas <strong>+50% calorías</strong></p>

        <h3>2. Incluye Inclinación</h3>
        <ul>
          <li>Sube escaleras</li>
          <li>Camina en pendientes</li>
          <li>Usa caminadora con inclinación</li>
        </ul>
        <p>→ Quemas <strong>+30-60% calorías</strong></p>

        <h3>3. Añade Peso (Mochila con Lastre)</h3>
        <p>Cargar 5-10 kg extra → quemas <strong>+10-20% calorías</strong></p>
        <p class="warning">⚠️ Solo si no tienes problemas de espalda/rodillas</p>

        <h3>4. Intervalos de Intensidad</h3>
        <p>Alterna 2 min rápido + 1 min moderado → quemas <strong>+25% calorías</strong></p>

        <h3>5. Camina Después de Comer</h3>
        <p>15-20 min después de comer mejora digestión y control de azúcar en sangre</p>

        <h2>Combinación con Nutrición</h2>

        <h3>Si tu objetivo es PERDER PESO:</h3>

        <div class="strategy-box">
          <p><strong>Calorías quemadas caminando:</strong> 350 kcal (70kg)</p>
          <p><strong>Déficit nutricional:</strong> 300 kcal/día</p>
          <p><strong>Déficit total:</strong> 650 kcal/día</p>
          <p><strong>Resultado:</strong> 0.9 kg/semana ✅</p>
        </div>

        <h3>Si tu objetivo es MANTENER PESO:</h3>

        <div class="strategy-box">
          <p><strong>Calorías quemadas:</strong> 350 kcal</p>
          <p><strong>Puedes comer:</strong> 350 kcal extra sin engordar</p>
          <p><strong>Ejemplo:</strong> 1 snack adicional (yogur + fruta + nueces)</p>
        </div>

        <h2>Mitos sobre Caminar</h2>

        <h3>❌ Mito 1: "10,000 pasos es obligatorio"</h3>
        <p><strong>Realidad:</strong> El número 10,000 es arbitrario (viene de una campaña de marketing japonesa en 1960). Lo importante es moverte más que antes.</p>

        <h3>❌ Mito 2: "Solo correr quema grasa"</h3>
        <p><strong>Realidad:</strong> Caminar quema grasa efectivamente, es menos estresante para articulaciones y más sostenible.</p>

        <h3>❌ Mito 3: "Caminar no construye músculo"</h3>
        <p><strong>Realidad:</strong> Caminar en pendientes SÍ tonifica piernas y glúteos.</p>

        <h2>Cómo Wayo Te Ayuda</h2>

        <ul class="wayo-features">
          <li>📌 Integra con tu smartwatch/celular para contar pasos</li>
          <li>📌 Calcula calorías quemadas según tu peso</li>
          <li>📌 Suma calorías de ejercicio a tu balance diario</li>
          <li>📌 Sugiere cuánto puedes comer extra según actividad</li>
        </ul>

        <div class="faq-section">
          <h4>¿Es mejor caminar 10,000 pasos de una vez o durante el día?</h4>
          <p>Ambos funcionan. Distribuir durante el día es más sostenible y mantiene metabolismo activo.</p>

          <h4>¿Puedo perder peso solo caminando?</h4>
          <p>Sí, combinado con déficit calórico. Caminar quema calorías pero si comes más de lo que quemas, no perderás peso.</p>

          <h4>¿Cuántos pasos debo hacer para perder 1 kg?</h4>
          <p>1 kg de grasa = 7,700 kcal. Si quemas 350 kcal/día extra caminando, necesitas ~22 días (10,000 pasos diarios).</p>
        </div>

      </div>
    `,
    image: "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=1200",
    author: "Wayo Team",
    date: "2026-02-21",
    category: "Fitness",
    tags: ["caminar", "10000 pasos", "calorías", "ejercicio", "pérdida de peso"],
    readTime: "12 min",
    metaDescription: "Entre 250 y 600 kcal según tu peso. Tabla de 50 a 100 kg, cuántos km son 10.000 pasos (unos 7,5) y cuánto tardas en hacerlos según tu ritmo.",
    keywords: ["cuántas calorías quemas caminando 10000 pasos", "calorías caminar", "10000 pasos calorías", "quemar calorías caminando"],
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "¿Cuántas calorías se queman con 10.000 pasos?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Caminar 10.000 pasos quema entre 300 y 500 kcal en la mayoría de personas, unas 30-50 kcal por cada 1.000 pasos. La cifra exacta depende de tu peso y ritmo: una persona de 60 kg quema unas 300-360 kcal y una de 90 kg, unas 450-540 kcal."
          }
        },
        {
          "@type": "Question",
          "name": "¿Cuántos kilómetros son 10.000 pasos?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "10.000 pasos equivalen aproximadamente a entre 7 y 8 kilómetros, según la longitud de tu zancada. Una persona de estatura media recorre unos 0,75 metros por paso."
          }
        },
        {
          "@type": "Question",
          "name": "¿Caminar 10.000 pasos al día adelgaza?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ayuda: 10.000 pasos diarios queman 300-500 kcal extra que, sumadas a un pequeño déficit calórico, permiten perder grasa de forma sostenible. Adelgazas si al final del día gastas más calorías de las que comes."
          }
        }
      ]
    }
  },

  // ARTÍCULO 19 - Cómo Llevar un Diario de Comidas
  {
    id: 119,
    slug: "como-llevar-diario-comidas-sin-volverte-loco",
    title: "Cómo Llevar un Diario de Comidas sin Obsesionarte",
    excerpt: "Guía práctica para llevar un diario de comidas de forma simple y sostenible. Métodos que funcionan, errores a evitar y cómo Wayo simplifica todo con IA.",
    content: `
      <div class="blog-article-extended">

        <p class="lead">Llevar un diario de comidas es <strong>la herramienta #1 para perder peso</strong> según estudios científicos. Pero el 87% de personas lo abandona en menos de 2 semanas.</p>

        <p>¿Por qué? Porque los métodos tradicionales son tediosos. Aquí aprenderás cómo hacerlo de forma simple.</p>

        <h2>Por Qué Funciona el Diario de Comidas</h2>

        <h3>📊 Evidencia Científica</h3>

        <ul>
          <li>✅ Estudio Kaiser Permanente (2008): Personas que llevan diario pierden <strong>2x más peso</strong></li>
          <li>✅ American Journal of Preventive Medicine: Registrar comidas aumenta conciencia en <strong>60%</strong></li>
          <li>✅ National Weight Control Registry: 90% de personas que mantienen pérdida de peso llevan registro</li>
        </ul>

        <h3>¿Por qué funciona?</h3>

        <ol>
          <li><strong>Crea conciencia:</strong> Te das cuenta de lo que REALMENTE comes</li>
          <li><strong>Elimina "bocados invisibles":</strong> Ese puñado de M&Ms suma 200 kcal</li>
          <li><strong>Identifica patrones:</strong> "Siempre como de más los viernes por la noche"</li>
          <li><strong>Responsabilidad:</strong> Si lo vas a registrar, piensas 2 veces antes de comerlo</li>
        </ol>

        <h2>Por Qué la Mayoría FALLA</h2>

        <h3>❌ Método tradicional (que NO funciona):</h3>

        <div class="fail-example">
          <ol>
            <li>Abre app</li>
            <li>Busca "pechuga de pollo" → 47 resultados diferentes</li>
            <li>¿Cuál es el correcto? No sabes</li>
            <li>Pesas la comida (si tienes balanza)</li>
            <li>Ingresas cantidad</li>
            <li>Repites para cada ingrediente (tomate, arroz, aceite...)</li>
            <li>15 minutos después... comida registrada</li>
          </ol>
          <p><strong>Resultado:</strong> Tedioso → abandonas en 10 días</p>
        </div>

        <h2>Métodos Simples que SÍ Funcionan</h2>

        <h3>Método 1: Solo Fotos (Sin Números)</h3>

        <p><strong>Cómo funciona:</strong></p>
        <ul>
          <li>Saca foto de TODO lo que comes</li>
          <li>NO calcules calorías</li>
          <li>Revisa fotos al final del día</li>
        </ul>

        <p><strong>Beneficio:</strong> Crea conciencia sin estrés. Puedes ver patrones visualmente.</p>

        <p><strong>Ideal para:</strong> Principiantes que se sienten abrumados con números</p>

        <h3>Método 2: Registro Minimalista</h3>

        <p><strong>Cómo funciona:</strong></p>
        <ul>
          <li>Anota solo 3 cosas:
            <ol>
              <li>Hora</li>
              <li>Qué comiste (general)</li>
              <li>Cómo te sentiste (hambre 1-10, emoción)</li>
            </ol>
          </li>
        </ul>

        <div class="example-box">
          <h4>Ejemplo:</h4>
          <p>8:00 AM - Avena con frutas - Hambre: 7/10 - Tranquilo</p>
          <p>1:00 PM - Ensalada con pollo - Hambre: 8/10 - Ocupado</p>
          <p>4:00 PM - Galletas (estrés laboral) - Hambre: 3/10 - Ansioso ⚠️</p>
        </div>

        <p><strong>Beneficio:</strong> Identificas patrones emocionales ("como cuando estoy ansioso")</p>

        <h3>Método 3: Escaneo con IA (Wayo)</h3>

        <p><strong>Cómo funciona:</strong></p>
        <ul>
          <li>Sacas foto de tu plato</li>
          <li>La IA detecta alimentos y porciones</li>
          <li>Calcula calorías y macros automáticamente</li>
          <li>Listo en 2 segundos</li>
        </ul>

        <p><strong>Beneficio:</strong> Precisión de registro completo + rapidez de solo fotos</p>

        <p><strong>Ideal para:</strong> Personas que quieren resultados sin perder tiempo</p>

        <h2>Reglas de Oro para NO Abandonar</h2>

        <h3>1. No busques perfección</h3>

        <p>❌ <strong>Mal:</strong> "No registré el desayuno, ya arruiné el día, abandonaré todo"</p>
        <p>✅ <strong>Bien:</strong> "No registré el desayuno, empiezo con el almuerzo"</p>

        <h3>2. Registra ANTES de comer (no después)</h3>

        <p>Beneficios:</p>
        <ul>
          <li>Te hace pensar: "¿Realmente quiero esto?"</li>
          <li>Puedes ajustar porciones antes de comer</li>
          <li>No olvidas alimentos</li>
        </ul>

        <h3>3. Usa el método más simple posible</h3>

        <p>Si pesar comida te estresa → NO lo hagas. Empieza con fotos.</p>

        <h3>4. Registra todo (incluso los "bocados")</h3>

        <ul>
          <li>2 galletas mientras cocinas: 150 kcal</li>
          <li>Los restos del plato del niño: 100 kcal</li>
          <li>Probaste la comida 3 veces: 80 kcal</li>
        </ul>
        <p><strong>Total: 330 kcal "invisibles"</strong> que arruinan tu déficit</p>

        <h3>5. Revisa tu diario semanalmente</h3>

        <p>Cada domingo dedica 10 minutos a:</p>
        <ul>
          <li>Revisar patrones: "¿Qué día comí mejor/peor?"</li>
          <li>Identificar desencadenantes: "Como de más cuando estoy estresado"</li>
          <li>Ajustar estrategia: "Voy a preparar snacks saludables para la oficina"</li>
        </ul>

        <h2>Cuándo Registrar Cada Comida</h2>

        <table class="timing-guide">
          <tr>
            <th>Momento</th>
            <th>Ventaja</th>
            <th>Desventaja</th>
          </tr>
          <tr>
            <td>Antes de comer</td>
            <td>✅ Te hace consciente, puedes ajustar</td>
            <td>⚠️ Requiere disciplina</td>
          </tr>
          <tr>
            <td>Mientras comes</td>
            <td>✅ No olvidas nada</td>
            <td>⚠️ Puede distraer del disfrute</td>
          </tr>
          <tr>
            <td>Después de comer</td>
            <td>✅ Más relajado</td>
            <td>❌ Olvidas detalles (aceite, salsas)</td>
          </tr>
          <tr>
            <td>Al final del día</td>
            <td>✅ Todo de una vez</td>
            <td>❌ Olvidas comidas/bocados</td>
          </tr>
        </table>

        <p><strong>Recomendación:</strong> ANTES o MIENTRAS comes (no después)</p>

        <h2>Errores Comunes</h2>

        <h3>❌ Error 1: Ser demasiado estricto</h3>

        <p>"Tengo que pesar cada gramo de comida"</p>
        <p><strong>Realidad:</strong> Estimaciones aproximadas funcionan bien. No necesitas precisión de laboratorio.</p>

        <h3>❌ Error 2: Registrar solo cuando comes "bien"</h3>

        <p>Omitir días malos → datos incompletos → no ves patrones reales</p>
        <p><strong>Solución:</strong> Los días "malos" son los MÁS importantes para registrar</p>

        <h3>❌ Error 3: Obsesionarse con los números</h3>

        <p>El registro debe ser una herramienta, no una obsesión.</p>
        <p><strong>Señales de alarma:</strong></p>
        <ul>
          <li>Ansiedad si no registras algo</li>
          <li>Evitas eventos sociales por no poder registrar</li>
          <li>Pesas comida en casa de amigos</li>
        </ul>
        <p><strong>Solución:</strong> Si sientes esto, toma un descanso del registro o usa método solo fotos</p>

        <h2>Cómo Wayo Hace Todo Esto Simple</h2>

        <ul class="wayo-features">
          <li>📸 <strong>Sacas foto:</strong> 2 segundos</li>
          <li>🤖 <strong>IA detecta alimentos:</strong> Automático</li>
          <li>⚖️ <strong>Calcula porciones:</strong> Sin pesar</li>
          <li>📊 <strong>Muestra calorías y macros:</strong> Instantáneo</li>
          <li>📈 <strong>Análisis semanal:</strong> Identifica patrones por ti</li>
          <li>💡 <strong>Sugerencias:</strong> "Has comido poca proteína hoy"</li>
        </ul>

        <p><strong>Resultado:</strong> Todo el beneficio del registro completo sin el esfuerzo</p>

        <div class="faq-section">
          <h4>¿Tengo que llevar diario para siempre?</h4>
          <p>No. Una vez que alcanzas tu objetivo y aprendes porciones/hábitos, puedes parar. Muchos lo retoman ocasionalmente (1 semana cada 3 meses) para verificar.</p>

          <h4>¿Qué hago en eventos sociales donde no puedo registrar?</h4>
          <p>Disfruta el momento. Registra lo que recuerdas después (aproximado) o simplemente sáltalo. Un día no arruina todo.</p>

          <h4>¿Es normal sentirse culpable cuando registro "mal"?</h4>
          <p>El registro no es para juzgarte, es para aprender. No hay días "buenos" o "malos", solo datos.</p>
        </div>

      </div>
    `,
    image: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=1200",
    author: "Wayo Team",
    date: "2026-02-23",
    category: "Nutrición",
    tags: ["diario de comidas", "registro", "hábitos", "pérdida de peso", "organización"],
    readTime: "14 min",
    metaDescription: "Métodos simples para registrar comidas sin estrés, errores que conviene evitar y cómo apoyarte en herramientas con IA para tardar menos.",
    keywords: ["diario de comidas", "cómo llevar registro comidas", "food journal", "registrar comidas app"]
  },

  // ARTÍCULO 20 - 10 Mitos de Nutrición
  {
    id: 120,
    slug: "10-mitos-nutricion-ciencia-vs-broscience",
    title: "10 Mitos de Nutrición que Siguen Frenando Resultados",
    excerpt: "Descubre los 10 mitos más populares sobre nutrición desmentidos por la ciencia. Carbohidratos, grasas, calorías y más: qué dice la evidencia real.",
    content: `
      <div class="blog-article-extended">

        <p class="lead">La nutrición está llena de <strong>mitos que simplemente no desaparecen</strong>. Algunos tienen décadas circulando, a pesar de que la ciencia los ha desmentido.</p>

        <p>Aquí están los 10 mitos más populares y qué dice la evidencia REAL.</p>

        <h2>Mito #1: "Los Carbohidratos Engordan"</h2>

        <h3>❌ El Mito:</h3>
        <p>Comer carbohidratos te hace engordar automáticamente. Debes evitarlos para perder peso.</p>

        <h3>✅ La Realidad Científica:</h3>
        <p>Los carbohidratos NO engordan por sí mismos. <strong>El exceso de calorías totales</strong> engorda, sin importar si vienen de carbohidratos, grasas o proteínas.</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Estudio American Journal of Clinical Nutrition (2017): Dietas bajas en grasa vs bajas en carbohidratos con MISMAS calorías → pérdida de peso idéntica</li>
            <li>Poblaciones más longevas del mundo (Okinawa, Cerdeña) comen 60-70% carbohidratos</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> Los carbohidratos de calidad (frutas, vegetales, granos integrales) son parte de una dieta saludable.</p>

        <h2>Mito #2: "Comer de Noche Engorda Más"</h2>

        <h3>❌ El Mito:</h3>
        <p>Las calorías consumidas después de las 6 PM se almacenan como grasa porque tu metabolismo se ralentiza por la noche.</p>

        <h3>✅ La Realidad:</h3>
        <p>Tu cuerpo NO tiene un reloj que apaga el metabolismo a las 6 PM. Lo que importa es <strong>tu balance calórico total del día (o semana)</strong>, no cuándo comes.</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Estudio British Journal of Nutrition (2020): No hay diferencia en pérdida de peso entre comer calorías temprano vs tarde</li>
            <li>Tu metabolismo basal funciona 24/7, incluso dormido</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> Come cuando prefieras. El problema de comer de noche es que muchas personas comen DE MÁS (snacks frente al TV), no el horario.</p>

        <h2>Mito #3: "La Grasa Alimentaria Te Hace Gordo"</h2>

        <h3>❌ El Mito:</h3>
        <p>"Comer grasa te hace gordo" → boom de productos "0% grasa" en los 90s.</p>

        <h3>✅ La Realidad:</h3>
        <p>Las grasas saludables son <strong>esenciales</strong> para hormonas, absorción de vitaminas y salud cerebral. No engordan más que otros macronutrientes (caloria por caloría).</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Dieta mediterránea (40% grasas saludables) → una de las más saludables del mundo</li>
            <li>Estudios muestran que reemplazar grasas con carbohidratos refinados EMPEORA la salud</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> Come grasas saludables (aguacate, aceite de oliva, nueces, pescado). Evita grasas trans.</p>

        <h2>Mito #4: "Necesitas Detox/Limpiezas"</h2>

        <h3>❌ El Mito:</h3>
        <p>Tu cuerpo acumula "toxinas" y necesitas jugos detox, tés de limpieza o ayunos para "limpiar" tu sistema.</p>

        <h3>✅ La Realidad:</h3>
        <p>Tu hígado y riñones <strong>ya hacen detox 24/7 gratis</strong>. No necesitas jugos de $50.</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>No hay evidencia científica de que "detox diets" eliminen toxinas</li>
            <li>Tu hígado procesa y elimina sustancias indeseadas automáticamente</li>
            <li>Los "detox" son básicamente dietas muy bajas en calorías → pierdes agua, no grasa</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> La mejor "limpieza" es comer vegetales, beber agua, dormir bien y evitar alcohol excesivo.</p>

        <h2>Mito #5: "El Desayuno es la Comida Más Importante"</h2>

        <h3>❌ El Mito:</h3>
        <p>"Saltarse el desayuno ralentiza tu metabolismo y te hace engordar"</p>

        <h3>✅ La Realidad:</h3>
        <p>No hay nada mágico en el desayuno. Algunas personas rinden mejor con desayuno, otras sin él (ayuno intermitente).</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Revisión sistemática (2019): No hay diferencia en pérdida de peso entre desayunar o no</li>
            <li>El mito viene de estudios financiados por... empresas de cereales</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> Come desayuno si tienes hambre. Si no, está bien saltarlo.</p>

        <h2>Mito #6: "La Proteína Daña los Riñones"</h2>

        <h3>❌ El Mito:</h3>
        <p>Comer mucha proteína (más de 1g/kg) daña tus riñones.</p>

        <h3>✅ La Realidad:</h3>
        <p>Si tus riñones están <strong>sanos</strong>, la proteína alta (hasta 2.5g/kg) NO causa daño.</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Revisión Journal of Nutrition (2018): No hay evidencia de daño renal en personas sanas</li>
            <li>El consejo de "proteína baja" es para personas CON enfermedad renal preexistente</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> 1.6-2.2g/kg es seguro y beneficioso para pérdida de peso/ganancia muscular.</p>

        <h2>Mito #7: "Los Huevos Aumentan el Colesterol"</h2>

        <h3>❌ El Mito:</h3>
        <p>Comer huevos aumenta tu colesterol en sangre y causa enfermedades cardíacas.</p>

        <h3>✅ La Realidad:</h3>
        <p>Para la mayoría de personas, el colesterol dietario (de comida) tiene <strong>poco impacto</strong> en el colesterol sanguíneo.</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Meta-análisis (2020): Consumir hasta 1 huevo/día NO aumenta riesgo cardiovascular</li>
            <li>Los huevos son uno de los alimentos más nutritivos (proteína, vitaminas, minerales)</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> 1-2 huevos al día es perfectamente saludable para la mayoría.</p>

        <h2>Mito #8: "Las Calorías No Importan, Solo los Macros"</h2>

        <h3>❌ El Mito:</h3>
        <p>"Puedes comer infinitas calorías si tus macros son correctos (ejemplo: keto)"</p>

        <h3>✅ La Realidad:</h3>
        <p>Las leyes de la termodinámica aplican a todos. <strong>Calorías in vs calorías out</strong> determina ganancia/pérdida de peso.</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Ninguna dieta (keto, vegana, paleo) viola las leyes físicas</li>
            <li>Estudio clásico "Twinkie Diet" (2010): Profesor perdió peso comiendo Twinkies porque mantuvo déficit calórico</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> Macros importan para saciedad, salud y composición corporal. Pero calorías totales determinan peso.</p>

        <h2>Mito #9: "Comer Cada 3 Horas Acelera el Metabolismo"</h2>

        <h3>❌ El Mito:</h3>
        <p>"Debes comer 6 comidas pequeñas al día para mantener tu metabolismo activo"</p>

        <h3>✅ La Realidad:</h3>
        <p>La frecuencia de comidas NO afecta significativamente tu metabolismo total.</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Revisión International Journal of Obesity: No hay diferencia metabólica entre 3 o 6 comidas/día con mismas calorías</li>
            <li>Lo que importa es el TOTAL de calorías, no cuántas veces comes</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> Come la frecuencia que prefieras: 2, 3, 5 o 6 comidas. Lo que te funcione.</p>

        <h2>Mito #10: "Los Alimentos Orgánicos Son Más Nutritivos"</h2>

        <h3>❌ El Mito:</h3>
        <p>Los alimentos orgánicos tienen más vitaminas, minerales y nutrientes que los convencionales.</p>

        <h3>✅ La Realidad:</h3>
        <p>La diferencia nutricional entre orgánico y convencional es <strong>mínima</strong>.</p>

        <div class="science-box">
          <h4>📚 Evidencia:</h4>
          <ul>
            <li>Revisión Stanford University (2012): No hay diferencia significativa en contenido nutricional</li>
            <li>Beneficio principal de orgánicos: menos pesticidas (no necesariamente más nutritivos)</li>
          </ul>
        </div>

        <p><strong>Conclusión:</strong> Compra orgánico si puedes/quieres evitar pesticidas. Pero vegetales convencionales son igual de nutritivos.</p>

        <h2>Resumen: Qué SÍ Importa Realmente</h2>

        <ol>
          <li>✅ <strong>Balance calórico total</strong> (déficit, superávit o mantenimiento)</li>
          <li>✅ <strong>Calidad de alimentos</strong> (naturales > ultraprocesados)</li>
          <li>✅ <strong>Proteína adecuada</strong> (1.6-2.2g/kg)</li>
          <li>✅ <strong>Consistencia a largo plazo</strong> (no dietas extremas de 2 semanas)</li>
          <li>✅ <strong>Dormir bien</strong> (7-8 horas)</li>
          <li>✅ <strong>Actividad física regular</strong> (pesas + cardio)</li>
        </ol>

        <div class="faq-section">
          <h4>¿Por qué persisten estos mitos?</h4>
          <p>Marketing de la industria alimentaria, simplificación excesiva de estudios científicos, y porque "soluciones mágicas" venden más que "come bien y sé consistente".</p>

          <h4>¿Cómo sé si algo es un mito o ciencia real?</h4>
          <p>Busca estudios revisados por pares, no anécdotas. Desconfía de afirmaciones absolutas ("NUNCA comas X") o productos que prometen resultados milagrosos.</p>

          <h4>¿Hay alguna "verdad universal" en nutrición?</h4>
          <p>Sí: Come principalmente alimentos reales/naturales, controla porciones, mantén proteína adecuada, muévete regularmente. El resto son detalles.</p>
        </div>

      </div>
    `,
    image: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200",
    author: "Wayo Team",
    date: "2026-02-25",
    category: "Nutrición",
    tags: ["mitos nutrición", "ciencia", "evidencia", "broscience", "salud"],
    readTime: "16 min",
    metaDescription: "Carbohidratos, detox, desayuno, grasas y otros mitos que aún confunden a mucha gente. Esto es lo que dice realmente la evidencia.",
    keywords: ["mitos nutrición", "mitos alimentación", "ciencia nutrición", "broscience", "verdades nutrición"]
  },

  // ARTÍCULO 21 - El Intercambiador de "Comida vs Pasos"
  {
    id: 216,
    slug: "cuantos-pasos-caminar-para-quemar-lo-que-comes-guia",
    faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "¿Cuántas calorías se queman con 10.000 pasos?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Entre 280 y 620 kcal según tu peso: unas 280 si pesas 50 kg, 400 si pesas 70 y 510 si pesas 90. De ese total, unas 80-100 las habrías gastado igual sin moverte."
                }
            },
            {
                "@type": "Question",
                "name": "¿Cuántos pasos hay que dar para quemar 500 calorías?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Unos 12.500 si pesas 70 kg y unos 10.000 si pesas 90. Eso son entre una hora y tres cuartos y dos horas de caminata."
                }
            },
            {
                "@type": "Question",
                "name": "¿Se puede adelgazar solo caminando?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Sí, pero por acumulación: 10.000 pasos diarios añaden unas 300 kcal al día, que en un mes son más de 1 kg de grasa. Lo que no funciona es caminar para compensar una comida concreta."
                }
            },
            {
                "@type": "Question",
                "name": "¿Cuántos kilómetros son 10.000 pasos?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Unos 7,5 km, aunque depende de tu zancada: entre 6,5 y 8 km según la altura. A ritmo normal son 1 hora y 40 minutos."
                }
            },
            {
                "@type": "Question",
                "name": "¿De verdad hay que hacer 10.000 pasos al día?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No. La cifra salió de una campaña publicitaria japonesa de los años 60. Los datos actuales sitúan la mayor parte del beneficio entre 7.000 y 8.000 pasos."
                }
            }
        ]
    },
    seoTitle: "¿Cuántos Pasos para Quemar lo que Comes? Tabla por Alimento",
    title: "¿Cuántos Pasos Hay que Caminar para Quemar lo que Comes?",
    excerpt: "No es lo mismo comerlo que quemarlo. Descubre la tabla definitiva de pasos necesarios para compensar tus comidas favoritas.",
    content: `
      <div class="blog-article-extended">
        <p class="lead">La respuesta rápida y algo incómoda: <strong>una persona de 70 kg quema unas 40 kcal cada 1.000 pasos.</strong> Así que un cruasán de 250 kcal son unos 6.200 pasos, y una pizza mediana entera, más de 20.000. Caminar es buenísimo, pero no está diseñado para deshacer lo que ya te has comido.</p>

        <h2>Cuánto quemas por 1.000 pasos según tu peso</h2>

        <p>Cuanto más pesas, más cuesta moverte y más quemas. Es la única variable que de verdad cambia el número:</p>

        <table class="comparison-table">
          <thead>
            <tr><th>Tu peso</th><th>1.000 pasos</th><th>10.000 pasos</th></tr>
          </thead>
          <tbody>
            <tr><td><strong>50 kg</strong></td><td>~28 kcal</td><td>~280 kcal</td></tr>
            <tr><td><strong>60 kg</strong></td><td>~34 kcal</td><td>~340 kcal</td></tr>
            <tr><td><strong>70 kg</strong></td><td>~40 kcal</td><td>~400 kcal</td></tr>
            <tr><td><strong>80 kg</strong></td><td>~45 kcal</td><td>~450 kcal</td></tr>
            <tr><td><strong>90 kg</strong></td><td>~51 kcal</td><td>~510 kcal</td></tr>
            <tr><td><strong>110 kg</strong></td><td>~62 kcal</td><td>~620 kcal</td></tr>
          </tbody>
        </table>

        <p>Y ojo con un detalle que casi nadie tiene en cuenta: <strong>de esas 400 kcal, unas 80-100 las habrías gastado igual estando sentado.</strong> El extra real de caminar 10.000 pasos ronda las 300, no las 400.</p>

        <h2>Cuántos pasos cuesta cada cosa que comes</h2>

        <p>Calculado para una persona de 70 kg. Redondea a la baja si pesas menos:</p>

        <table class="comparison-table">
          <thead>
            <tr><th>Lo que te has comido</th><th>Calorías</th><th>Pasos para quemarlo</th></tr>
          </thead>
          <tbody>
            <tr><td>Una manzana</td><td>80 kcal</td><td>2.000</td></tr>
            <tr><td>Una cerveza (caña)</td><td>90 kcal</td><td>2.250</td></tr>
            <tr><td>Un puñado de almendras (30 g)</td><td>180 kcal</td><td>4.500</td></tr>
            <tr><td>Un cruasán</td><td>250 kcal</td><td>6.250</td></tr>
            <tr><td>Una tostada con aceite y tomate</td><td>250 kcal</td><td>6.250</td></tr>
            <tr><td>Una porción de tortilla de patatas</td><td>280 kcal</td><td>7.000</td></tr>
            <tr><td>Una lata de refresco + bolsa de patatas</td><td>400 kcal</td><td>10.000</td></tr>
            <tr><td>Un bocadillo de jamón</td><td>450 kcal</td><td>11.250</td></tr>
            <tr><td>Una hamburguesa de menú</td><td>550 kcal</td><td>13.750</td></tr>
            <tr><td>Una pizza mediana entera</td><td>850 kcal</td><td>21.250</td></tr>
            <tr><td>Un menú completo de comida rápida</td><td>1.100 kcal</td><td>27.500</td></tr>
          </tbody>
        </table>

        <div class="warning-box">
          <h3>Por eso no se adelgaza andando después de comer</h3>
          <p>21.250 pasos son unas 3 horas y media caminando. Nadie sostiene eso a diario, y por eso la estrategia de "ya lo quemaré luego" no funciona nunca.</p>
          <p><strong>Es muchísimo más fácil no comerse la mitad de la pizza que caminar 10.000 pasos extra.</strong> No es una cuestión de fuerza de voluntad, es de aritmética.</p>
        </div>

        <h2>Entonces, ¿para qué sirve caminar?</h2>

        <p>Para bastantes cosas, ninguna de las cuales es "borrar" una comida:</p>

        <ul>
          <li><strong>Sube tu gasto de base.</strong> 10.000 pasos diarios son ~300 kcal extra al día = <strong>2.100 a la semana</strong>. Eso sí mueve la báscula, pero por acumulación, no por compensación puntual.</li>
          <li><strong>No te da hambre.</strong> A diferencia del cardio intenso, caminar apenas dispara el apetito, así que las calorías que gastas no se recuperan comiendo.</li>
          <li><strong>Se puede sostener.</strong> Puedes caminar todos los días de tu vida. No puedes hacer HIIT todos los días de tu vida.</li>
          <li><strong>Protege el músculo</strong> mientras estás en déficit, cosa que el cardio largo e intenso no siempre hace.</li>
        </ul>

        <div class="example-box">
          <p><strong>La cuenta que sí importa:</strong> 300 kcal extra al día caminando, sostenidas un mes, son 9.000 kcal. Poco más de <strong>1 kilo de grasa</strong> sin haber tocado la dieta.</p>
          <p>Sin cambiar nada más, eso son 12 kg al año. Ese es el poder de caminar, y no tiene nada que ver con compensar el postre del domingo.</p>
        </div>

        <h2>De pasos a kilómetros y a tiempo</h2>

        <table class="comparison-table">
          <thead>
            <tr><th>Pasos</th><th>Distancia aprox.</th><th>Tiempo a ritmo normal</th></tr>
          </thead>
          <tbody>
            <tr><td>1.000</td><td>0,75 km</td><td>10 min</td></tr>
            <tr><td>5.000</td><td>3,8 km</td><td>50 min</td></tr>
            <tr><td>7.500</td><td>5,6 km</td><td>1 h 15 min</td></tr>
            <tr><td>10.000</td><td>7,5 km</td><td>1 h 40 min</td></tr>
            <tr><td>15.000</td><td>11,3 km</td><td>2 h 30 min</td></tr>
          </tbody>
        </table>

        <p>Los 10.000 pasos, por cierto, no salen de ningún estudio: vienen de una campaña de marketing de un podómetro japonés de los años 60. Los datos actuales apuntan a que <strong>la mayor parte del beneficio para la salud aparece entre los 7.000 y los 8.000</strong>, y que a partir de ahí la curva se aplana. Si llegas a 8.000, ya has cogido casi todo.</p>

        <h2>Cómo meter pasos sin sacar tiempo</h2>

        <ul>
          <li><strong>Bájate una parada antes.</strong> 1.500-2.000 pasos que no notas.</li>
          <li><strong>Llamadas de pie y andando.</strong> Una llamada de 20 minutos son 2.000.</li>
          <li><strong>Diez minutos después de comer.</strong> Suma unos 1.000 y además ayuda con la glucosa posprandial.</li>
          <li><strong>Escaleras siempre.</strong> Cuentan doble en gasto por paso.</li>
          <li><strong>La compra a pie</strong> en vez de en coche, dos veces por semana.</li>
        </ul>

        <h2>Preguntas frecuentes</h2>

        <div class="faq-section">
          <h3>¿Cuántas calorías se queman con 10.000 pasos?</h3>
          <p>Entre 280 y 620 kcal según tu peso: unas 280 si pesas 50 kg, 400 si pesas 70 y 510 si pesas 90. De ese total, unas 80-100 las habrías gastado igual sin moverte.</p>

          <h3>¿Cuántos pasos hay que dar para quemar 500 calorías?</h3>
          <p>Unos 12.500 si pesas 70 kg, y unos 10.000 si pesas 90. Eso son entre 1 hora y 45 minutos y 2 horas de caminata.</p>

          <h3>¿Se puede adelgazar solo caminando?</h3>
          <p>Sí, pero por acumulación: 10.000 pasos diarios añaden unas 300 kcal al día, que en un mes son más de 1 kg de grasa. Lo que no funciona es caminar para compensar una comida concreta.</p>

          <h3>¿Cuántos kilómetros son 10.000 pasos?</h3>
          <p>Unos 7,5 km, aunque depende de tu zancada: entre 6,5 y 8 km según la altura. A ritmo normal son 1 hora y 40 minutos.</p>

          <h3>¿De verdad hay que hacer 10.000 pasos al día?</h3>
          <p>No. La cifra salió de una campaña publicitaria japonesa de los años 60. Los datos actuales sitúan la mayor parte del beneficio entre 7.000 y 8.000 pasos, con la curva aplanándose después.</p>
        </div>

        <div class="key-takeaways">
          <h3>Lo que hay que recordar</h3>
          <ul>
            <li><strong>~40 kcal por cada 1.000 pasos</strong> a 70 kg. Escala con tu peso.</li>
            <li><strong>Un cruasán son 6.250 pasos.</strong> Compensar comiendo menos es infinitamente más fácil.</li>
            <li><strong>El valor de caminar es acumulativo:</strong> 300 kcal/día = 1 kg al mes.</li>
            <li><strong>No dispara el hambre,</strong> a diferencia del cardio intenso.</li>
            <li><strong>Con 7.000-8.000 ya tienes casi todo el beneficio.</strong> Los 10.000 son marketing de los 60.</li>
          </ul>
        </div>

        <div class="cta-box">
          <h3>Los pasos son la parte fácil de medir</h3>
          <p>Lo difícil es saber qué has comido de verdad, que es donde se decide todo. Con <strong>Wayo</strong> haces una foto al plato y tienes las calorías en segundos.</p>
          <p><a href="https://wayoai.app/download" class="cta-button">Probar Wayo</a></p>
        </div>

        <div class="related-articles">
          <h3>Sigue leyendo</h3>
          <ul>
            <li><a href="/blog/cuantas-calorias-quemas-caminando-10000-pasos">Cuántas calorías quemas caminando 10.000 pasos</a></li>
            <li><a href="/blog/cuantas-calorias-para-bajar-1-kilo">Cuántas calorías son 1 kilo</a></li>
            <li><a href="/blog/mejores-ejercicios-quemar-grasa-2026">Los mejores ejercicios para quemar grasa</a></li>
            <li><a href="/blog/alimentos-bajos-calorias-perder-peso">50 alimentos bajos en calorías que sacian</a></li>
          </ul>
        </div>
      </div>
    `,
    image: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1200",
    author: "Wayo Team",
    date: "2026-03-14",
    category: "Estilo de Vida",
    tags: ["pasos", "quemar calorías", "adelgazar", "ejercicio", "viral"],
    readTime: "7 min",
    metaDescription: "Un cruasán son 6.250 pasos y una pizza entera 21.250. Tabla de pasos por alimento, cuánto quemas según tu peso y por qué compensar comiendo menos es más fácil.",
    keywords: ["cuantos pasos para quemar hamburguesa", "equivalencia pasos calorias", "quemar comida caminando"]
  },

  // ARTÍCULO 22 - El mito de las "Calorías Negativas"
  {
    id: 217,
    slug: "alimentos-calorias-negativas-mito-realidad",
    title: "Alimentos con Calorías Negativas: La Verdad Sin Mitos",
    excerpt: "¿Existen alimentos que queman más energía de la que aportan? Analizamos el apio, el pepino y otros 'superalimentos'.",
    content: `
      <div class="blog-article-extended">
        <p class="lead">Seguro que lo has oído: "Come apio, tiene calorías negativas porque el cuerpo gasta más en digerirlo que lo que el apio aporta". <strong>¿Es verdad?</strong></p>

        <p>La respuesta corta es: <strong>no exactamente</strong>. Pero sí existen alimentos con un efecto térmico alto, mucha saciedad y muy pocas calorías, lo que los convierte en aliados potentes para perder grasa sin pasar hambre.</p>

        <h2>El efecto térmico de los alimentos (TEF)</h2>
        <p>Tu cuerpo gasta energía procesando lo que comes:</p>
        <ul>
          <li><strong>Proteínas:</strong> gastas el 20-30% de sus calorías solo en digerirlas.</li>
          <li><strong>Carbohidratos:</strong> gastas el 5-10%.</li>
          <li><strong>Grasas:</strong> solo el 0-3%.</li>
        </ul>

        <h2>Los "casi negativos" que debes conocer</h2>
        <p>1. Apio: 16 kcal/100g<br>2. Pepino: 15 kcal/100g<br>3. Espárragos: 20 kcal/100g</p>

        <div class="info-box">
          <h4>La Estrategia Wayo</h4>
          <p>Usa estos alimentos como volumen. Llenan tu plato, mejoran la saciedad y apenas suman al contador diario. Cuando los escaneas con Wayo, entiendes enseguida cómo construir platos más grandes visualmente pero más ligeros en calorías.</p>
        </div>

        <h2>Entonces, ¿son un mito total?</h2>
        <p>Como concepto literal, sí: no existen alimentos mágicos que hagan desaparecer calorías por arte de magia. Pero como herramienta práctica para comer más volumen con menos energía, estos alimentos son oro puro.</p>
      </div>
    `,
    image: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=1200",
    author: "Wayo Team",
    date: "2026-03-14",
    category: "Nutrición",
    tags: ["calorías negativas", "adelgazar", "nutrición", "mitos alimentarios"],
    readTime: "11 min",
    metaDescription: "¿De verdad existen los alimentos con calorías negativas? Te explicamos qué hay de cierto y qué sí conviene comer si buscas saciedad.",
    keywords: ["alimentos calorías negativas", "adelgazar comiendo apio", "mitos nutrición 2026"]
  },

  // ARTÍCULO 23 - Alcohol y Macros
  {
    id: 218,
    slug: "alcohol-y-dieta-como-beber-sin-engordar",
    title: "Alcohol y Dieta: Cómo Beber Sin Tirar la Semana",
    excerpt: "Guía de supervivencia para eventos sociales. Qué bebidas elegir y cómo compensar el alcohol en tu contador de calorías.",
    content: `
      <div class="blog-article-extended">
        <p class="lead">El alcohol son "calorías vacías", pero la vida social también es salud. <strong>¿Se puede beber y perder grasa?</strong> Sí, si sabes cómo.</p>

        <p>El objetivo no es vivir con miedo a una copa de vino o a una caña el fin de semana. El objetivo es entender qué impacto tiene cada bebida, qué elecciones son más inteligentes y cómo evitar que una noche social arruine toda tu semana.</p>

        <h2>El ranking de bebidas: de menos a más calóricas</h2>
        <ol>
          <li><strong>Copa de vino blanco o tinto:</strong> ~120 kcal (bajo en azúcar)</li>
          <li><strong>Cerveza (caña):</strong> ~90-100 kcal</li>
          <li><strong>Combinado (destilado + refresco zero):</strong> ~100-120 kcal</li>
          <li><strong>Cócteles (mojito, piña colada):</strong> +300 kcal ⚠️</li>
        </ol>

        <div class="winner-box">
          <h4>💡 El Truco del Vaso de Agua</h4>
          <p>Por cada copa de alcohol, bebe un vaso de agua. Mantendrás la hidratación, el metabolismo más estable y reducirás el hambre brutal del día siguiente.</p>
        </div>

        <h2>Cómo registrarlo en Wayo</h2>
        <p>No te escondas de la app. Si bebes, regístralo. Wayo te ayuda a mantener el contexto de tu día y a tomar mejores decisiones después, en lugar de caer en el típico "ya la he liado, sigo comiendo fatal".</p>

        <h2>La clave no es prohibir, es planificar</h2>
        <p>Si sabes que vas a cenar fuera o tomar algo, puedes ajustar antes el resto del día. Esa flexibilidad es lo que hace sostenible una estrategia de pérdida de grasa realista.</p>
      </div>
    `,
    image: "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=1200",
    author: "Wayo Team",
    date: "2026-03-14",
    category: "Estilo de Vida",
    tags: ["alcohol", "macros", "dieta flexible", "social", "calorías"],
    readTime: "10 min",
    metaDescription: "Guía práctica para beber alcohol sin arruinar tu progreso: calorías por bebida, mejores elecciones y trucos para el fin de semana.",
    keywords: ["alcohol calorias dieta", "beber vino adelgazar", "calorias cerveza vs vino"]
  }
];
